import { ShieldCheck, Award } from "lucide-react";
import { useLang } from "../context/LanguageContext";

export const CertificatePreview = ({ title, hours }) => {
  const { t } = useLang();
  return (
    <div className="mt-10" data-testid="certificate-preview">
      <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-[#1D4ED8]">{t("cert.previewEyebrow")}</p>
      <h2 className="font-heading font-black text-xl md:text-lg text-[#0B1B3A] mt-2">{t("cert.previewTitle")}</h2>
      <div className="mt-5 rounded-[24px] border border-[#E2E8F0] bg-white p-5 sm:p-8 shadow-[0_24px_60px_-30px_rgba(11,27,58,0.35)]">
        <div className="relative rounded-2xl border-[6px] border-[#0B1B3A] p-6 sm:p-10 bg-[linear-gradient(135deg,#ffffff_0%,#EEF4FF_100%)] overflow-hidden">
          <div className="absolute -right-16 -top-16 w-48 h-48 rounded-full bg-[#1D4ED8]/10" />
          <div className="absolute -left-10 -bottom-10 w-32 h-32 rounded-full border-[10px] border-[#1D4ED8]/10" />
          <div className="relative flex items-start justify-between gap-4">
            <p className="text-[10px] sm:text-xs font-black uppercase tracking-[0.3em] text-[#1D4ED8]">SportScience Academy</p>
            <Award className="w-8 h-8 sm:w-10 sm:h-10 text-[#1D4ED8]" />
          </div>
          <p className="relative mt-8 text-[10px] sm:text-xs uppercase tracking-[0.24em] text-[#64748B]">{t("cert.certifies")}</p>
          <p className="relative mt-2 font-heading font-black text-2xl sm:text-3xl text-[#0B1B3A]">{t("cert.holderPlaceholder")}</p>
          <p className="relative mt-4 text-sm text-[#475569]">{t("cert.completed")}</p>
          <p className="relative mt-1 font-heading font-black text-lg sm:text-xl text-[#1D4ED8]">{title}</p>
          <div className="relative mt-8 flex flex-wrap items-end justify-between gap-4">
            <div className="text-xs text-[#64748B]">
              {hours ? <p>{hours} {t("cert.hours")}</p> : null}
              <p className="mt-1">{t("cert.idLine")}</p>
            </div>
            <span className="inline-flex items-center gap-2 px-3 py-2 rounded-full bg-[#0B1B3A] text-white text-[10px] font-bold uppercase tracking-[0.14em]">
              <ShieldCheck className="w-3.5 h-3.5" /> {t("cert.verified")}
            </span>
          </div>
        </div>
        <p className="text-xs text-[#64748B] mt-4">{t("cert.previewNote")}</p>
      </div>
    </div>
  );
};
